import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';

const SuccessModal = ({
  isOpen,
  title,
  message,
  buttonLabel,
  onButtonClick,
  onClose = () => {}
}: {
  isOpen: boolean;
  title: string;
  message: string;
  buttonLabel: string;
  onButtonClick: () => void;
  onClose?: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeButtonProps={{ hidden: true }}
      width="lg"
    >
      <Flex flexDirection="column" gap={3} p={4} textAlign="center">
        <Text textAlign={'left'} textStyle="headingSection">
          {title}
        </Text>
        <Text textAlign={'left'} textStyle="textContext" color="gray.600">
          {message}
        </Text>
        <Button marginLeft={'auto'} onClick={onButtonClick}>
          {buttonLabel}
        </Button>
      </Flex>
    </Modal>
  );
};

export default SuccessModal;
